import styled from 'styled-components';
import Typography from '../typography/Typography';
export const PageNotFoundContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.4rem;
  margin-top: ${({ shouldHaveMargin }) => (shouldHaveMargin ? '10rem' : '0')};
  margin-bottom: 2rem;
`;
export const PageNotFounImg = styled.img `
  width: 34.6rem;
  height: 25rem;
`;
export const ButtonWrapper = styled.div `
  width: 19.8rem;
`;
export const Description = styled(Typography) `
  width: 30rem;
  text-align: center;
`;
//# sourceMappingURL=styles.js.map